<script>
	import listBase from '@_system/components/base/list.vue'
	import tabs from './tabs/main.vue';
	import split from './split/index.vue';
	import join from './join/index.vue';
	import uploadinvoice from './uploadinvoice/index.vue';
	import invoicing from './invoicing/index.vue';
	import exportTable from '@_system/components/export/index.vue'
	export default {
		extends: listBase,
		name: 'invoiceoutputIndex',
		props: {

		},
		render(h) {
			this.$slots.footer = [
				<tabs ref="tab" item={this.item} key={this.tabKey} />
			]
			this.$slots.plug = [
				<invoicing ref="invoicingForm" currentrow={this.currentrow} onSuccess={this.invoicingSuccess} />,
				<vxe-modal v-model={this.splitShow} width="800" height="700" show-footer destroy-on-close transfer
					lock-scroll={false}>
					<template slot="title">
						<div>拆分</div>
					</template>
					<template slot="default">
						<div style="margin-top: 10px;">
							<split ref="split" row={this.currentrow} />
						</div>
					</template>
					<template slot="footer">
						<vxe-button status="" content="取消" onClick={()=>{this.splitShow=false}}></vxe-button>
						<vxe-button status="primary" content="确定" onClick={this.splitSubmit}></vxe-button>
					</template>
				</vxe-modal>,
				<vxe-modal v-model={this.joinShow} width="800" height="700" show-footer destroy-on-close transfer
					lock-scroll={false}>
					<template slot="title">
						<div>合并</div>
					</template>
					<template slot="default">
						<div style="margin-top: 10px;">
							<join ref="join" row={this.currentrow} />
						</div>
					</template>
					<template slot="footer">
						<vxe-button status="" content="取消" onClick={()=>{this.joinShow=false}}></vxe-button>
						<vxe-button status="primary" content="确定" onClick={this.joinSubmit}></vxe-button>
					</template>
				</vxe-modal>,
				
				<vxe-modal v-model={this.uploadinvoiceShow} width="800" height="700" show-footer destroy-on-close transfer
					lock-scroll={false}>
					<template slot="title">
						<div>上传发票</div>
					</template>
					<template slot="default">
						<div style="margin-top: 10px;">
							<uploadinvoice ref="join" row={this.currentrow} />
						</div>
					</template>
					<template slot="footer">
						<vxe-button status="" content="返回" onClick={()=>{this.uploadinvoiceShow=false}}></vxe-button>
						
					</template>
				</vxe-modal>,
			]
			return listBase.render.call(this, h)
		},
		data() {
			return {
				invoiceattrItem: [],
				loading: false,
				exportData: [],
				currentrow: null,
				item: null,
				tabKey: Math.random(),
				moduleName: 'invoiceoutput',
				windowName: '发票销项',
				splitShow: false,
				joinShow: false,
				uploadinvoiceShow:false,
				// exportCustomColumn: [{
				// 	title: '开票模板',
				// 	label: 'invoicetemplate',
				// 	field: [
				// 		'number',
				// 		'invoicecompany',
				// 		'invoicetime',
				// 		'invoicecode',
				// 		'invoiceattr',
				// 		'invoicetitle',
				// 		'typename',
				// 		'invoicenum',
				// 		'invoiceamountwithtax',
				// 		'invoicetaxid',
				// 		'invoiceaddress',
				// 		'invoicephone',
				// 		'invoicebank',
				// 		'invoicebankaccount',
				// 		'addresseeemail',
				// 		'issend',
				// 		'invoicepreamount',
				// 		'mark',
				// 		'staffid',
				// 		'invoicetypeclass',
				// 		'invoicetypeunit',
				// 	]
				// }],
				exportFieldType: 'invoicetemplate',
				pagerConfig: {
					autoHidden: false,
					border: true,
					size: 'mini',
					perfect: false,
					currentPage: 1,
					pageSize: 100,
					pageSizes: [100, 200, 500,1000],
				},
				// splitform: {
				// 	id: 0,
				// 	tptid: '',
				// 	amount: 0,
				// 	splitamount: 0
				// }
			}
		},
		watch: {

		},
		created() {
			
		},
		mounted() {
			// this.$refs[this.exportRef].exportCustomColumn = this.exportCustomColumn
			let exportComponent = this.$refs[this.exportRef]
			exportComponent.exportcurrent = (obj)=>{
				let list = this.moduleName ? this.moduleName : this.reportName
				let ids = []
				let checkData = this.$refs[list + '_list'].getCheckboxRecords()
				if (checkData.length == 0) {
					checkData = this.$refs[list + '_list'].getTableData().fullData
				}
				checkData.forEach((item) => {
					ids.push(item.id)
				})
				obj.ids = ids
				this.$api[this.moduleName].export(obj).then((res) => {
					res.data.forEach((item)=>{
						item.invoicetime = this.$systemMethods.timestampToDate(item.invoicetime,true)
					})
					exportComponent.afterexport(res)
					exportComponent.exportData(res)
					exportComponent.list.loading = false
				}, () => {
					exportComponent.list.loading = false
				})
			}

			
			// setTimeout(()=>{
			// 	this.exportMethod()
			// },500)
		},
		computed: {

		},

		methods: {
			yqdzinvoicebatch(){
				let checkData = this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if (checkData.length == 0) {
					this.$message.error('请选择数据')
				} else {
					this.loading = true
					let ids = checkData.map((item)=>{
						return item.id
					})
					this.$api.invoiceoutput.download({ids:ids}).then((blob) => {
						this.loading = false
						const url = window.URL.createObjectURL(blob);
						const a = document.createElement('a');
						a.style.display = 'none';
						a.href = url;
						a.download = '纳智销项亿企赢数电批量开票模板.xlsx';
						document.body.appendChild(a);
						a.click();
						window.URL.revokeObjectURL(url);
					}, () => {
						this.loading = false
					})
				}
			},
			// cellStyle({
			// 	row,
			// 	column
			// }) {
			
			// 	if (row.sourcenumber) {
			// 		return {
			// 			backgroundColor: 'rgb(253, 226, 226)'
			// 		}
			// 	}
			// 	if (row.emergent == 1 && column.field == 'number' && !row.invoicecode) {
			// 		return {
			// 			color: '#FFFFFF',
			// 			backgroundColor: '#F56C6C'
			// 		}
			// 	}
			// 	if (row.urgent == 1 && column.field == 'number' && !row.invoicecode) {
			// 		return {
			// 			color: '#F56C6C'
			// 		}
			// 	}
			// },
			beforeCreateGrid(formConfig, columns){
				columns.forEach((item)=>{
					if(item.field=='tptid'){
						item.slots = {
							default: ({row}) => {	
								let str= []
								if(row.emergent){
									str.push(<el-tag title="2小时内开出" size="mini" type="danger" effect="dark" style="margin-right: 2px;">急</el-tag>)
								}else if(row.urgent){
									str.push(<el-tag title="加急" size="mini" type="danger" style="margin-right: 2px;">急</el-tag>)
								}
								str.push(<span>{row.tptid}</span>)
								return str
							}
						}
					}
				})
			},
			file(row) {
				if (row.invoicecode) {
					if(row.invoiceurl){
						window.open(row.invoiceurl)
					}else{
						window.open('https://nazhi.oss-cn-hangzhou.aliyuncs.com/fapiao/'+row.invoicecode+'.pdf')
					}
					return
				}else{
					this.$message.error('暂未开票')
				}

			},
			sendemail(row) {
				this.$confirm('确认发送发票文件?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.loading = true
					this.$api.invoiceoutput.sendemail(row.id).then(() => {
						this.$message.success('操作成功')
						this.customreload()
						this.loading = false
					}, () => {
						this.loading = false
					})
				}).catch(() => {
			
				})
			
			},
			// beforeCreateGrid(formConfig, columns){
			// 	console.log(columns)
			// },
			// beforeRender(data) {
			// 	let list = data.list
			// 	list.forEach((item) => {
			// 		if (item.emergent == 1 && !item.invoicecode) {
			// 			item.number = '(紧急)' + item.number
			// 		}else if (item.urgent == 1 && !item.invoicecode) {
			// 			item.number = '(加急)' + item.number
			// 		}else{
			// 			return
			// 		}
			// 	})

			// },

			createExportAttr() {
				let data = []
				let select = []
				window.systemData.emun.forEach((item) => {
					if (item.field == 'invoiceattr') {
						data.push(item)
						select.push(item.id)
					}
				})
				this.exportConfig.push({
					title: '发票类型',
					field: 'invoiceattr',
					type: 'emun',
					data: data,
					select: select
				})
				data = []
				select = []
				window.systemData.emun.forEach((item) => {
					if (item.field == 'invoicestatus') {
						data.push(item)
						if (item.id == 319 || item.id == 334) {
							select.push(item.id)
						}

					}
				})
				this.exportConfig.push({
					title: '开票状态',
					field: 'invoicestatus',
					type: 'emun',
					data: data,
					select: select
				})

			},




			invoice(row) {
				this.currentrow = row
				if (row.flowstatus == 0) {
					this.$message.error('销项未审核')
					return false
				}
				if (row.invoicestatus != 319 && row.invoicestatus != 333 && row.invoicestatus != 334) {
					this.$nextTick(()=>{
						this.$refs.invoicingForm.modal_show()
					})
					
					// this.$api[this.moduleName].getbyinvoicestatus(319, {
					// 	tptid: row.tptid
					// }).then((res) => {
					// 	if (res) {
					// 		this.$confirm(row.tptid + '</br>订单存在开票记录，请确认是否继续开票?', '提示', {
					// 			confirmButtonText: '确定',
					// 			cancelButtonText: '取消',
					// 			dangerouslyUseHTMLString: true,
					// 			type: 'warning'
					// 		}).then(() => {
					// 			this.invoiceform(row)
					// 		}).catch(() => {

					// 		})
					// 	} else {
					// 		this.invoiceform(row)
					// 	}

					// })
				} else {
					this.$message.error('已开票')
				}
			},
			uninvoice(row) {
				this.$confirm(row.tptid + '</br>是否撤销开票?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					dangerouslyUseHTMLString: true,
					type: 'warning'
				}).then(() => {
					this.$api[this.moduleName].uninvoice(row.id).then(() => {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					})
				}).catch(() => {
			
				})
			},
			invoiceform(row) {
				import('@/components/forms/finance/invoicematch/form.vue').then((res) => {
					this.formModule = {
						component: res.default,
						name: 'invoicematch',
						id: row.id,
						controlltype: 2,
						windowName: '开票',
						show: true,
						extra: {
							type: 'invoice',

						}
					}
				})
			},
		
			
			autopullorders() {

				let rows = []
				let count = 0
				let checkData = this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if (checkData.length == 0) {
					this.$message.error('请选择销项')
				} else {
					checkData.forEach((item) => {
						//if (item.flowstatus != 0) {
							rows.push(item)
						//}
					})
					this.loading = true
					rows.forEach((row) => {
						this.$refs.toolorders.row = row
						this.$refs.toolorders.orders = row.orders
						this.$refs.toolorders.pull({
							row: row
						}).then(() => {
							count++
							if (count >= rows.length) {
								this.loading = false
								this.customreload()
							}
						})
					})
				}

			},
			invoicingSuccess(){
				this.customreload()
			},
			autoinvoice() {
				let ids = []
				let checkData = this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if (checkData.length == 0) {
					this.$message.error('请选择销项')
				} else {
					checkData.forEach((item) => {
						if (item.flowstatus != 0) {
							ids.push(item.id)
						}
					})
					this.$confirm('是否确认自动开票', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.loading = true
						this.$api.invoicematch.autoinvoice({
							ids: ids
						}).then((res) => {
							if (res.error.length != 0) {
								let error = []
								res.error.forEach((item) => {
									error.push(item.number + '：' + item.message)
								})
								this.$alert(error.join('</br>'), '未完成序列号', {
									confirmButtonText: '确定',
									dangerouslyUseHTMLString: true,
								})
							}
							this.loading = false
							this.customreload()
						}, () => {
							this.loading = false
						})
					}).catch(() => {

					})
				}

			},

			split(row) {
				if (row.flowstatus == 0) {
					this.$message.error('销项未审核')
					return false
				}
				if (row.invoicestatus == 318) {
					this.currentrow = row
					this.splitShow = true


				} else {
					this.$message.error('已开票')
				}
			},
			uploadinvoice(){
				this.uploadinvoiceShow = true
			},
			uploadinvoiceSubmit(){
				this.uploadinvoiceShow = false
			},
			join(row) {
				if (row.flowstatus == 0) {
					this.$message.error('销项未审核')
					return false
				}
				if (row.invoicestatus == 318) {
					this.currentrow = row
					this.joinShow = true

				} else {
					this.$message.error('已开票')
				}


				// this.$confirm('是否确认合并', '提示', {
				// 	confirmButtonText: '确定',
				// 	cancelButtonText: '取消',
				// 	type: 'warning'
				// }).then(() => {
				// 	this.$api[this.moduleName].joinorder(row.id).then(() => {
				// 		this.$message({
				// 			message: '操作成功',
				// 			type: 'success'
				// 		})
				// 		this.customreload()
				// 	})
				// }).catch(() => {

				// })

			},
			autoremark() {
				let ids = []
				let checkData = this.$refs[this.moduleName + '_list'].getCheckboxRecords()
				if (checkData.length == 0) {
					this.$message.error('请选择销项')
				} else {
					checkData.forEach((item) => {
						ids.push(item.id)
					})
					this.$confirm('是否确认自动备注', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.loading = true
						this.$api[this.moduleName].remarkonline({
							ids: ids
						}).then((res) => {
							if (res.length == 0) {
								this.$message.success('操作成功')
							} else {
								this.$alert(res.join('</br>'), '未完成序列号', {
									confirmButtonText: '确定',
									dangerouslyUseHTMLString: true,
								})
							}
							this.loading = false
							this.customreload()
						}, () => {
							this.loading = false
						})
					}).catch(() => {

					})
				}

			},
			remarkonline(row) {
				this.$api[this.moduleName].remarkonline({
					ids: [row.id]
				}).then((res) => {
					if (res.length == 0) {
						this.$message.success('操作成功')
					} else {
						this.$alert(res.join('</br>'), '未完成序列号', {
							confirmButtonText: '确定',
							dangerouslyUseHTMLString: true,
						})
					}
					this.customreload()
				})

			},


			joinSubmit() {
				let data = this.$refs.join.submit()
				if (data) {
					this.$api[this.moduleName].joinorder(data.id, data).then(() => {
						this.joinShow = false
						this.customreload()
					})
				}
			},
			splitSubmit() {
				let data = this.$refs.split.submit()
				if (data) {
					this.$api[this.moduleName].splitorder(data.id, data).then(() => {
						this.splitShow = false
						this.customreload()
					})
				}
			},
			reissue(row) {
				if (row.flowstatus == 0) {
					this.$message.error('销项未审核')
					return false
				}
				if (row.invoicestatus == 333 || row.invoicestatus == 334) {
					this.$confirm('是否确认重开：系统单号 ' + row.ordercode, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$api[this.moduleName].reissue(row.id).then(() => {
							this.customreload()
						})
					}).catch(() => {

					})
					//console.log(this.moduleName)


				} else {
					this.$message.error('发票状态不为作废或冲红')
				}
			},
			drop(row) {
				if (row.flowstatus == 0) {
					this.$message.error('销项未审核')
					return false
				}
				if (row.invoicestatus == 319) {
					if (row.invoicestatus != 333) {
						this.$confirm('是否确认作废：序列号 ' + row.number, '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.$api[this.moduleName].drop(row.id).then(() => {
								this.$message({
									message: '操作成功',
									type: 'success'
								})
								this.customreload()
							})
						}).catch(() => {

						})
					} else {
						this.$message.error('发票已作废')
					}
				} else {
					this.$message.error('发票状态不为已开票')
				}
			},
			reversal(row) {
				if (row.flowstatus == 0) {
					this.$message.error('销项未审核')
					return false
				}
				// if (row.reversalnumber) {
				// 	this.$alert('发票已冲红，冲红发票序列号：' + row.reversalnumber, {
				// 		confirmButtonText: '确定',
				// 		title: '提示',
				// 		type: 'warning '
				// 	})
				// } else if (row.invoicestatus == 334) {
				// 	this.$alert('发票已冲红', {
				// 		confirmButtonText: '确定',
				// 		title: '提示',
				// 		type: 'warning '
				// 	})
				// 	this.$alert('无法二次冲红，来源发票序列号：' + row.sourcenumber, {
				// 		confirmButtonText: '确定',
				// 		title: '提示',
				// 		type: 'warning '
				// 	})
				// } else 
				if (row.invoicestatus != 319) {
					this.$message.error('发票状态不为已开票')
				} else {
					this.$confirm('是否确认冲红：序列号 ' + row.number, '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$api[this.moduleName].reversal(row.id).then(() => {
							this.$message({
								message: '操作成功',
								type: 'success'
							})
							this.customreload()
						})
					}).catch(() => {

					})
				}



			},
			cellClick({
				row,
				column
			}) {

				if (this.item && this.item.id == row.id || column.field == '') {
					return
				} else {
					this.item = row
					this.$refs.tab.reload()
				}
			},
			importMethod(e) {
				let file = e.file
				let formData = new FormData()
				formData.append('excle', file)
				return new Promise((resolve) => {
					this.loading = true
					this.$api[this.moduleName].import(formData).then((res) => {
						if (res.errorData.length != 0) {
							let message = ''
							res.errorData.forEach((item) => {
								message = message + item.number + '：' + item.erro + '</br>'
							})
							this.$alert(message + '系统已忽略', res.errorData.length + '条数据错误', {
								dangerouslyUseHTMLString: true
							})
						} else {
							this.$message.success('导入成功')
						}
						this.loading = false
						this.customreload()
						this.reload()
						resolve()

					}, (e) => {
						this.loading = false
						this.$message.error(e)
						resolve()
					})
				})

			},
			importtemplate() {
				this.$store.commit('getTemplate', 'invoiceoutputaddress')
			},
			del(row) {
				this.$confirm('是否确认删除 ' + (row.number ? row.number : ''), '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api[this.moduleName].delete(row.id).then(() => {
						this.$message({
							message: '操作成功',
							type: 'success'
						})
						this.customreload()
					})
				}).catch(() => {

				})
			},
			beforeRequest() {
				this.item = null
				//this.$refs.tab.reload()
			}

		},
		components: {
			tabs,
			split,
			join,
			exportTable,
			invoicing,
		}
	}
</script>
